import { render, staticRenderFns } from "./Step-3.vue?vue&type=template&id=31a98380&"
import script from "./Step-3.vue?vue&type=script&lang=js&"
export * from "./Step-3.vue?vue&type=script&lang=js&"
import style0 from "./Step-3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports